import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';


class ScheduleGradeAircraftLineCrew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      sgas_id: this.props.sgas_id,
      staffs_list: this.props.staffs_list,
      remaining_staffs_list: this.props.remaining_staffs_list,
      schedule_staffs_list: this.props.schedule_staffs_list,
      staff: this.props.staff,
      schedule_used_regime_list: this.props.schedule_used_regime_list,
      staff_id: this.props.staff_id,
      edit_mode: this.props.edit_mode,
      show_select: 0,
      modal: false,
      show_div: false,
    };

    this.locale = getLocale();

    this.changeShowModalDiv = this.changeShowModalDiv.bind(this);
    this.toggleSelect = this.toggleSelect.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.staff_id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      if(newProps.staff === null) {
        this.setState({staff: this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.staffIndisponivel});
      } else {
        this.setState({staff: newProps.staff});
      }
      if(newProps.staff_id === 0) {
        this.setState({staff_id: null});
        this.setState({staff: this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.staffNAOTRIPULADA});
      } else {
        this.setState({staff_id: newProps.staff_id});
      }
      this.setState({
        sgas_id: newProps.sgas_id,
        staffs_list: newProps.staffs_list,
        remaining_staffs_list: newProps.remaining_staffs_list,
        loaded: 1,
        schedule_used_regime_list: newProps.schedule_used_regime_list,
        show_select: 0,
        modal: false,
        show_div: false,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});

  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    if (event == null || typeof event.value === 'undefined') {
      this.props.changeStaffIdToNT(this.state.sgas_id);
    } else {
      if (this.state.show_select === 1 && event !== null && this.state[name] !== event.value) {
        if (this.props.staff === null) {
          this.setState({modal: true});
        } else {
          this.props.changeStaffId(this.state.sgas_id, event.value);
        }
      }
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }


  // exibe o select
  toggleSelect() {
    if(this.state.edit_mode) {
      this.setState({show_select: 1});
    }
  }

  // Fecha select quando pressionada a tecla esc
  escFunction(event){
    if(event.keyCode === 27) {
      this.setState({show_select: 0});
    }
  }

  // Fecha modal
  closeModal(event){
    this.setState({modal: false});
  }

  // Exibe div com select de staff com tripulaçoes da aeronave
  changeShowModalDiv(event){
    this.setState({show_div: event});
  }
  refreshGrades (event) {
  }

  handleSelectChangeRegime(name, event) {
    var self = this;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    Object.keys(self.props.schedule_used_regimes).map(function(k) {
      var sur = self.props.schedule_used_regimes[k];
      if (sur.id === event.value) {
        self.setState({start_day: sur.start_day_str});
      }
    })
  }

  render() {
    var self = this;
    var alert_level = self.props.alert_level;
    if(self.props.alert_level === null) alert_level = 'default';
    return (
  <td className={"text-center table-schedule-sticky schedule-days-editable table-schedule-main-name-" + self.props.zoom_level} onClick={this.toggleSelect} style={self.props.style_fb}>
    <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />

    {(self.state.show_select === 0) ?
      <div>
        {self.state.staff}
        <br />
        {!self.state.edit_mode && <button className={'btn btn-' + alert_level + ' btn-xs'} onClick={() => self.props.generatePersonalAlerts(self.state.sgas_id)}><i className="fa fa-warning"></i></button>}
      </div>
    :
      <Select
        className="form-field-name"
        name="staff_id"
        value={this.state.staff_id}
        searchable={true}
        placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.placeholder.Indisponivel}
        onChange={this.handleSelectChange.bind(this, 'staff_id')}
        options={this.state.staffs_list}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
        styles={{
          // Fixes the overlapping problem of the component
          menuList: provided => ({ ...provided, zIndex: 9999, position: 'fixed !important' }),
          menuPortal: provided => ({ ...provided, zIndex: 9999, position: 'fixed !important' }),
          menu: provided => ({ ...provided, zIndex: 9999, position: 'fixed !important' })
        }}
      />
    }
      <Modal show={this.state.modal} bsSize="large" aria-labelledby="contained-modal-title-lg">
        <Modal.Header>
          <h4 className="pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.tituloEscolherQuinzena}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Regime}:</label>
                <Select
                  className="form-field-name"
                  name="schedule_used_regime_id"
                  value={this.state.schedule_used_regime_id}
                  searchable={true}
                  placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.placeholder.SelecionarRegime}
                  onChange={this.handleSelectChangeRegime.bind(this, 'schedule_used_regime_id')}
                  options={this.state.schedule_used_regime_list}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.DataInicial}:</label>
                <InputMask value={this.state.start_day}  maskChar={null} name="start_day" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'start_day')} placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.placeholder.DataInicial} />
              </div>
            </div>
          </div>
          <hr/>
          <div className="form-group">
            <button type="button" className="btn btn-primary btn-lg btn-block"  onClick={() => (this.props.addStaffWithPeriod(this.state.schedule_used_regime_id, this.state.start_day, this.state.sgas_id, this.state.staff_id))}><i className="fa fa-fw fa-save"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.botaoAdicionarAEscala}</button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
  </td>
    );
  }
}

export default ScheduleGradeAircraftLineCrew;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineCrew.js